"use strict";
/**
 * @private
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CS_FLEET_ENDPOINT = {
    getVehicleDetails: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}',
    patchVehicleDetails: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}',
    getGpsPosition: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/request-gps-coordinates',
    getImmobilize: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/immobilize',
    getMobilize: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/mobilize',
    getOpenDoors: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/open',
    getCloseDoors: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/close',
    getOpenAsAdmin: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/open-as-admin',
    getCloseAsAdmin: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/close-as-admin',
    getDescriptions: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/descriptions',
    getDamages: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/damages',
    getEquipments: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/equipments',
    putEquipments: '/backoffice/cs-fleet/{{version}}/vehicles/{{vehicleUuid}}/equipments',
    getComments: '/backoffice/comments/vehicle/{{vehicleUuid}}',
    postComment: '/backoffice/comments',
    putComment: '/backoffice/comments/{{vehicleUuid}}',
    deleteComment: '/backoffice/comments/{{vehicleUuid}}',
};
